import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Button, TextField, InputAdornment } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { TransactionTable, Getwaytransactions } from "../../redux/Actions/transactionsService";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import TransactionModal from "../../Modals/transactionModal";
import Loader from "../../Loader";
import moment from "moment";
import { Box, IconButton, Tooltip, Chip } from "@mui/material";
import GetTransactionModal from "../../Modals/GetTransactionModal";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import BarChartIcon from "@mui/icons-material/BarChart";

const TransactionsTable = () => {
  const dispatch = useDispatch();
  const [transactionData, settransactionData] = useState([]);
  const [openTransModal, settransactionopenTransModal] = useState(false);
  const [opengetTransModal, setgetTransModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const { transData, loading, gateWaylist, status } = useSelector((state) => state.transaction);

  useEffect(() => {
    dispatch(TransactionTable());
  }, []);

  useEffect(() => {
    if (transData) {
      settransactionData(transData?.transfers || []);
      setFilteredData(transData?.transfers || []);
    }
  }, [transData]);

  // Filter data based on search text
  useEffect(() => {
    if (!searchText.trim()) {
      setFilteredData(transactionData);
    } else {
      const filtered = transactionData.filter((item) => {
        if (!item) return false;
        
        const displayUserName = item?.userRole?.user?.userInfo?.firstName || "";
        const email = item?.userRole?.user?.email || "";
        const displayCustodianName = item?.custodian || "";
        const action = item?.action || "";
        const amount = item?.amount || "";
        const status = item?.status || "";
        const regDate = item?.createdAt ? moment(item.createdAt)?.format("DD/MM/YYYY") : "";
        
        const searchLower = searchText.toLowerCase();
        
        return (
          (displayUserName && displayUserName.toLowerCase().includes(searchLower)) ||
          (email && email.toLowerCase().includes(searchLower)) ||
          (displayCustodianName && displayCustodianName.toLowerCase().includes(searchLower)) ||
          (action && action.toLowerCase().includes(searchLower)) ||
          (amount && amount.toString().includes(searchLower)) ||
          (status && status.toLowerCase().includes(searchLower)) ||
          (regDate && regDate.includes(searchLower))
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, transactionData]);

  const handleVerifyClick = (transactionData) => {
    setSelectedTransaction(transactionData);
    settransactionopenTransModal(true);
  };

  const handleViewClick = (transactionData) => {
    dispatch(Getwaytransactions({userId:transactionData?.userId, custodianId:transactionData?.custodianId, type:transactionData?.type})).then(
      setgetTransModal(true)
    )
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleDownload = () => {
    // Create CSV content
    const csvContent = [
      // Header row
      ["#", "Name", "Email", "Custodian", "Type", "Amount", "Status", "Date"].join(","),
      // Data rows
      ...filteredData.map((item, index) => {
        if (!item) return "";
        
        const displayUserName = item?.userRole?.user?.userInfo?.firstName || "";
        const email = item?.userRole?.user?.email || "";
        const displayCustodianName = item?.custodian || "";
        const action = item?.action || "";
        const amount = item?.amount || "";
        const status = item?.status || "";
        const regDate = item?.createdAt ? moment(item.createdAt)?.format("DD/MM/YYYY") : "";
        
        return [
          index + 1,
          `"${displayUserName}"`,
          `"${email}"`,
          `"${displayCustodianName}"`,
          `"${action}"`,
          amount,
          `"${status}"`,
          `"${regDate}"`
        ].join(",");
      })
    ].join("\n");

    // Create and download file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `transactions_${moment().format("YYYY-MM-DD")}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePrint = () => {
    // Create print content
    const printContent = `
      <html>
        <head>
          <title>Transaction Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .header { text-align: center; margin-bottom: 20px; }
            .date { text-align: right; margin-bottom: 20px; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Transaction Management Report</h1>
          </div>
          <div class="date">
            Generated on: ${moment().format("DD/MM/YYYY HH:mm:ss")}
          </div>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Custodian</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              ${filteredData.map((item, index) => {
                if (!item) return "";
                
                const displayUserName = item?.userRole?.user?.userInfo?.firstName || "";
                const email = item?.userRole?.user?.email || "";
                const displayCustodianName = item?.custodian || "";
                const action = item?.action || "";
                const amount = item?.amount || "";
                const status = item?.status || "";
                const regDate = item?.createdAt ? moment(item.createdAt)?.format("DD/MM/YYYY") : "";
                
                return `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${displayUserName}</td>
                    <td>${email}</td>
                    <td>${displayCustodianName}</td>
                    <td>${action}</td>
                    <td>$${amount ? amount.toLocaleString() : "0"}</td>
                    <td>${status}</td>
                    <td>${regDate}</td>
                  </tr>
                `;
              }).join("")}
            </tbody>
          </table>
        </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };

  const handleAnalytics = () => {
    // Calculate analytics
    const totalTransactions = filteredData.length;
    const completedTransactions = filteredData.filter(item => item?.status?.toLowerCase() === "completed").length;
    const pendingTransactions = filteredData.filter(item => item?.status?.toLowerCase() === "pending").length;
    const failedTransactions = filteredData.filter(item => item?.status?.toLowerCase() === "failed").length;
    const totalAmount = filteredData.reduce((sum, item) => sum + (item?.amount || 0), 0);
    const depositCount = filteredData.filter(item => item?.action?.toLowerCase() === "deposit").length;
    const withdrawCount = filteredData.filter(item => item?.action?.toLowerCase() === "withdraw").length;

    const analyticsData = {
      totalTransactions,
      completedTransactions,
      pendingTransactions,
      failedTransactions,
      totalAmount,
      depositCount,
      withdrawCount,
      completionRate: totalTransactions > 0 ? ((completedTransactions / totalTransactions) * 100).toFixed(2) : 0
    };

    // Show analytics in alert (you can replace this with a modal)
    alert(`
Transaction Analytics:
- Total Transactions: ${analyticsData.totalTransactions}
- Completed: ${analyticsData.completedTransactions} (${analyticsData.completionRate}%)
- Pending: ${analyticsData.pendingTransactions}
- Failed: ${analyticsData.failedTransactions}
- Total Amount: $${analyticsData.totalAmount.toLocaleString()}
- Deposits: ${analyticsData.depositCount}
- Withdrawals: ${analyticsData.withdrawCount}
    `);
  };

  const handleFilter = () => {
    // Toggle filter visibility (this would typically show/hide filter options)
    // You can implement a filter modal or dropdown here
  };

  const handleFilterTable = () => {
    // Toggle the built-in MUI DataTable filters
    const tableElement = document.querySelector('.MUIDataTable');
    if (tableElement) {
      const filterRow = tableElement.querySelector('.MUIDataTable-filterList');
      if (filterRow) {
        filterRow.style.display = filterRow.style.display === 'none' ? 'block' : 'none';
      }
    }
  };

  const columns = [
    {
      name: "#",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          style: {
            textAlign: "left",
            fontSize: "14px",
            fontWeight: 500,
          },
        }),
        customBodyRender: (value) => {
          return (
            <Box sx={{ 
              fontSize: "12px", 
              fontWeight: 500, 
              textAlign: "left",
              color: "#6b7280"
            }}>
              {value}
            </Box>
          );
        },
      },
    },
    {
      name: "Name",
      options: {
        filter: true,
        filterType: "textField",
        customBodyRender: (value) => {
          return (
            <Box sx={{ 
              fontSize: "14px", 
              fontWeight: 600,
              color: "#1f2937",
            }}>
              {value || "N/A"}
            </Box>
          );
        },
      },
    },
    {
      name: "Email",
      options: {
        filter: true,
        filterType: "textField",
        customBodyRender: (value) => {
          return (
            <Box sx={{ 
              fontSize: "14px", 
              color: "#6b7280",
              maxWidth: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
             
            }}>
              {value || "N/A"}
            </Box>
          );
        },
      },
    },
    {
      name: "Custodian",
      options: {
        filter: true,
        filterType: "dropdown",
        customBodyRender: (value) => {
          return (
            <Chip
              label={value || "N/A"}
              size="small"
              sx={{
                backgroundColor: "#eff6ff",
                color: "#1e40af",
                fontWeight: 500,
                fontSize: "12px",
                height: "24px"
              }}
            />
          );
        },
      },
    },
    {
      name: "Type",
      options: {
        filter: true,
        filterType: "dropdown",
        customBodyRender: (value) => {
          const isDeposit = value?.toLowerCase() === "deposit";
          return (
            <Chip
              label={value || "N/A"}
              size="small"
              sx={{
                backgroundColor: isDeposit ? "#f0fdf4" : "#fef3c7",
                color: isDeposit ? "#166534" : "#92400e",
                fontWeight: 500,
                fontSize: "12px",
                height: "24px"
              }}
            />
          );
        },
      },
    },
    {
      name: "Amount",
      options: {
        filter: true,
        filterType: "textField",
        customBodyRender: (value) => {
          return (
            <Box sx={{ 
              fontSize: "14px", 
              fontWeight: 700, 
              color: "#059669"
            }}>
              ${value ? value.toLocaleString() : "0"}
            </Box>
          );
        },
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        filterType: "dropdown",
        customBodyRender: (value) => {
          let backgroundColor = "";
          let color = "";
          let icon = null;

          const lowerValue = value?.toLowerCase();

          switch (lowerValue) {
            case "pending":
              backgroundColor = "#fef3c7";
              color = "#92400e";
              icon = <HourglassEmptyIcon sx={{ fontSize: 16 }} />;
              break;
            case "completed":
              backgroundColor = "#f0fdf4";
              color = "#166534";
              icon = <CheckCircleIcon sx={{ fontSize: 16 }} />;
              break;
            case "failed":
              backgroundColor = "#fef2f2";
              color = "#dc2626";
              icon = <CancelIcon sx={{ fontSize: 16 }} />;
              break;
            default:
              backgroundColor = "#f3f4f6";
              color = "#6b7280";
              break;
          }

          return (
            <Chip
              icon={icon}
              label={value || "N/A"}
              size="small"
              sx={{
                backgroundColor: backgroundColor,
                color: color,
                fontWeight: 500,
                fontSize: "12px",
                height: "28px",
                "& .MuiChip-icon": {
                  color: color
                }
              }}
            />
          );
        },
      },
    },
    {
      name: "Date",
      options: {
        filter: true,
        filterType: "textField",
        setCellHeaderProps: () => ({
          style: {
          textAlign:'left !important'
          },
        }),
        customBodyRender: (value) => {
          return (
            <Box sx={{ 
              fontSize: "14px", 
              color: "#6b7280",
              fontWeight: 500
            }}>
              {value || "N/A"}
            </Box>
          );
        },
      },
    },
    {
      name: "Actions",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          style: {
            fontSize: "14px",
            fontWeight: "500 ",
            textTransform:'uppercase'
          },
        }),
        customBodyRender: (value, tableMeta) => {
          const transactiondata = filteredData[tableMeta.rowIndex];
          const clientUserStatus = transactiondata?.status?.toLowerCase();
          
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {clientUserStatus === "pending" && (
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    borderRadius: "6px",
                    backgroundColor: "#3b82f6",
                    color: "white",
                    textTransform: "none",
                    fontSize: "12px",
                    fontWeight: 500,
                    px: 2,
                    py: 0.5,
                    minWidth: "80px",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#2563eb",
                      boxShadow: "0 2px 4px rgba(59, 130, 246, 0.3)",
                    },
                  }}
                  onClick={() => handleVerifyClick(transactiondata)}
                >
                  Verify
                </Button>
              )}
            </Box>
          );
        },
      },
    },
  ];

  const uppercaseColumns = ["Transaction type", "Custodian", "Status"];
  const sortedData = filteredData?.map((item, index) => {
    if (!item) return null;
    
    const { action, amount, status, createdAt, userId, custodianId } = item;
    
    // Get name from userInfo (for INDIVIDUAL investors)
    const userInfo = item?.userRole?.user?.userInfo;
    const firstName = userInfo?.firstName || "";
    const lastName = userInfo?.lastName || "";
    const userFullName = [firstName, lastName].filter(Boolean).join(" ").trim();
    
    // Get name from entityInfo (for CORPORATE/TRUST investors)
    const entityInfo = item?.userRole?.entityInfo;
    const entityName = entityInfo?.name || "";
    
    // Prioritize userInfo name, fall back to entityInfo name, then "N/A"
    const displayUserName = userFullName || entityName || "N/A";
    
    const email = item?.userRole?.user?.email || "";
    const displayCustodianName = item?.custodian || "";
    const transformedCutodian = uppercaseColumns.includes("Custodian") ? displayCustodianName?.toUpperCase() : displayCustodianName;
    const transformedType = uppercaseColumns.includes("Transaction type") ? action?.toUpperCase() : action;
    const transformedStatus = uppercaseColumns.includes("Status") ? status?.toUpperCase() : status;
    const regDate = createdAt ? moment(createdAt)?.format("DD/MM/YYYY") : "";
    
    return {
      "#": index + 1,
      "Name": displayUserName,
      "Email": email,
      "Custodian": transformedCutodian,
      "Type": transformedType,
      "Amount": amount,
      "Status": transformedStatus,
      "Date": regDate,
    };
  }).filter(Boolean); // Remove null entries

  const options = {
    filter: true,
    responsive: "standard",
    selectableRows: "none",
    rowsPerPage: 8,
    rowsPerPageOptions: [8, 16, 24],
    pagination: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filterType: "dropdown",
    // tableBodyHeight: "auto",
    // tableBodyMaxHeight: "none",
    tableBodyHeight: "55vh",
    tableBodyMaxHeight: "55vh",
    customToolbar: () => (
      <Box sx={{ 
        width: "100%",
        display: "flex", 
        gap: 2, 
        p: 3,
        borderBottom: "1px solid #e5e7eb",
    
        marginLeft:"-20px"
      }}>
        <Box sx={{ flexGrow: 1 }}>
          <TextField
            fullWidth
            placeholder="Search transactions..."
            value={searchText}
            onChange={handleSearchChange}
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#9ca3af", fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
            sx={{
              maxWidth: "400px",
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                borderRadius: "8px",
                "& fieldset": {
                  borderColor: "#e5e7eb",
                },
                "&:hover fieldset": {
                  borderColor: "#d1d5db",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#3b82f6",
                },
              },
              "& .MuiInputBase-input": {
                fontSize: "14px",
                color: "#374151",
                "&::placeholder": {
                  color: "#9ca3af",
                  opacity: 1,
                },
              },
            }}
          />
        </Box>
        
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title="Download CSV">
            <IconButton 
              size="small" 
              onClick={handleDownload}
              sx={{ 
                color: "#6b7280",
                backgroundColor: "white",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                width: "40px",
                height: "40px",
                "&:hover": { 
                  color: "#374151", 
                  backgroundColor: "#f3f4f6",
                  borderColor: "#d1d5db"
                }
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Print Report">
            <IconButton 
              size="small" 
              onClick={handlePrint}
              sx={{ 
                color: "#6b7280",
                backgroundColor: "white",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                width: "40px",
                height: "40px",
                "&:hover": { 
                  color: "#374151", 
                  backgroundColor: "#f3f4f6",
                  borderColor: "#d1d5db"
                }
              }}
            >
              <PrintIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="View Analytics">
            <IconButton 
              size="small" 
              onClick={handleAnalytics}
              sx={{ 
                color: "#6b7280",
                backgroundColor: "white",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                width: "40px",
                height: "40px",
                "&:hover": { 
                  color: "#374151", 
                  backgroundColor: "#f3f4f6",
                  borderColor: "#d1d5db"
                }
              }}
            >
              <BarChartIcon />
            </IconButton>
          </Tooltip>
         
        </Box>
      </Box>
    ),
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box sx={{ width: "100%" }}>
          <MUIDataTable
            title=""
            data={sortedData}
            columns={columns}
            options={options}
          />
        </Box>
      )}
      <TransactionModal
        openTransModal={openTransModal}
        settransactionopenTransModal={settransactionopenTransModal}
        selectedTransaction={selectedTransaction}
        setSelectedTransaction={setSelectedTransaction}
      />
      <GetTransactionModal
        opengetTransModal={opengetTransModal}
        data={gateWaylist}
        onClose={() => setgetTransModal(false)}
      />
    </>
  );
};

export default TransactionsTable;
